import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import router from './routes';
import { setViewport, setMultipleLangs } from '@dana/components';
import { RouterProvider } from 'react-router-dom';
import '@dana/components/index.css';
// 自动加载语言包
// @ts-ignore
const langContext = require.context('./lang', false, /lang\.[a-z]{2}\.json$/);
// @ts-ignore
const privacyPolicyContext = require.context('./lang', false, /privacy_policy\.[a-z]{2}\.json$/);
// @ts-ignore
const userAgreementContext = require.context('./lang', false, /user_agreement\.[a-z]{2}\.json$/);

// 合并语言包
const mergedLangModules: Record<string, Record<string, string>> = {};

// 加载 lang 文件
langContext.keys().forEach((key: string) => {
  const match = key.match(/lang\.([a-z]{2})\.json$/);
  if (match) {
    const langCode = match[1];
    if (!mergedLangModules[langCode]) {
      mergedLangModules[langCode] = {};
    }
    Object.assign(mergedLangModules[langCode], langContext(key));
  }
});

// 加载 privacy_policy 文件
privacyPolicyContext.keys().forEach((key: string) => {
  const match = key.match(/privacy_policy\.([a-z]{2})\.json$/);
  if (match) {
    const langCode = match[1];
    if (!mergedLangModules[langCode]) {
      mergedLangModules[langCode] = {};
    }
    Object.assign(mergedLangModules[langCode], privacyPolicyContext(key));
  }
});

// 加载 user_agreement 文件
userAgreementContext.keys().forEach((key: string) => {
  const match = key.match(/user_agreement\.([a-z]{2})\.json$/);
  if (match) {
    const langCode = match[1];
    if (!mergedLangModules[langCode]) {
      mergedLangModules[langCode] = {};
    }
    Object.assign(mergedLangModules[langCode], userAgreementContext(key));
  }
});

// 设置合并后的语言包
const langConfigs = Object.entries(mergedLangModules).map(([key, value]) => ({
  key,
  value,
}));
setMultipleLangs(langConfigs);

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

// 在页面加载时调用该函数
// window.addEventListener('resize', setViewport); // 监听窗口大小变化

root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>,
);

setViewport();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
